/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-30 18:01:19
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 16:36:53
 */
import { unwrapResult } from "@reduxjs/toolkit";
import { Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { CirclePieCharts } from "../../components/CirclePieCharts";
import { Skeleton } from "../HealthPrisonAnaylse/Skeleton";
import styles from "./WarningRulesAnaylse.module.css";
import { getWarningRuleAnaylseData } from "./WarningRulesAnaylseSilce";

/* 规则执法占比 */
export const Anaylse = () => {
  const [time, setTime] = useState();

  const [lawEnforceData, setLawEnforceData] = useState<any>([]);

  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(getWarningRuleAnaylseData({ dType: 3, scope: time }))
      .then(unwrapResult)
      .then((res) => {
        setLawEnforceData(
          res.map((v) => {
            return {
              name: v.provRuleName,
              value: v.total || undefined,
            };
          })
        );
      });
  }, [dispatch, time]);
  return (
    <div className={styles.EnableRules}>
      <div className={styles.rulesSelect}>
        <h3>预警规则处置占比分析</h3>
        <Radio.Group
          defaultValue={time}
          onChange={(e: any) => {
            setTime(e.target.value);
          }}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio.Button value={0}>近七天</Radio.Button>
          <Radio.Button value={1}>近30天</Radio.Button>
          <Radio.Button value={2}>近一年</Radio.Button>
          <Radio.Button>全部</Radio.Button>
        </Radio.Group>
      </div>
      <div className={styles.rulesContent}>
        {lawEnforceData.length ? (
          <CirclePieCharts
            pieData={lawEnforceData}
            style={{ height: "100%" }}
          />
        ) : (
          <Skeleton infoMsg="此页面暂无数据" />
        )}
      </div>
    </div>
  );
};
